// Statement dialog/page helpers: dates, remembered preferences, remark truncation (CUSTOMER-STATEMENT.md §4, §7).

const PREFS_KEY = 'customerStatementPrefs';
const DEFAULT_PREFS = { view: 'CUSTOMER', lineage: false, remarkChars: 15 };

const pad = (n) => String(n).padStart(2, '0');

// Local calendar date → YYYY-MM-DD (toISOString would shift the day in UAE time).
export const toIsoDate = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

export const defaultStatementRange = (today = new Date()) => {
  const from = new Date(today.getFullYear(), today.getMonth() - 3, today.getDate() + 1);
  return { from: toIsoDate(from), to: toIsoDate(today) };
};

export const loadStatementPrefs = () => {
  try {
    const saved = JSON.parse(window.localStorage.getItem(PREFS_KEY) || 'null');
    return saved ? { ...DEFAULT_PREFS, ...saved } : { ...DEFAULT_PREFS };
  } catch {
    return { ...DEFAULT_PREFS };
  }
};

export const saveStatementPrefs = (prefs) => {
  try {
    window.localStorage.setItem(PREFS_KEY, JSON.stringify(prefs));
  } catch {
    // Storage blocked — preferences simply aren't remembered.
  }
};

// maxChars 0 = full text.
export const truncateRemark = (text, maxChars) => {
  const t = text || '';
  if (!maxChars || t.length <= maxChars) return t;
  return `${t.slice(0, maxChars - 1)}…`;
};
